import type { PropsWithChildren } from 'react';
import { classNames } from '~/utils/classNames';

export const Badge = ({
  children,
  className,
  type = 'neutral',
}: PropsWithChildren<{ className?: string; type?: 'neutral' | 'warning' | 'error' | 'info' | 'success' }>) => {
  return (
    <span
      className={classNames(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-bolt-ds-surfaceOne text-bolt-ds-textPrimary min-w-14',
        {
          'bg-bolt-ds-neutralContainer': type === 'neutral',
          'bg-bolt-ds-warningContainer text-bolt-ds-warning': type === 'warning',
          'bg-bolt-ds-dangerContainer text-bolt-ds-danger': type === 'error',
          'bg-bolt-ds-brandContainer text-bolt-ds-brand': type === 'info',
          'bg-bolt-ds-successContainer text-bolt-ds-success': type === 'success',
        },
        className,
      )}
    >
      {children}
    </span>
  );
};
